import React from "react";
import Grid from "@mui/material/Grid2";
import styles from "../LandingPage.module.css";
import { Button, TextField, Typography } from "@mui/material";
import { motion } from "framer-motion";
import { useForm, ValidationError } from "@formspree/react";

const Contact = () => {
  const [state, handleSubmit] = useForm("mannadba");

  if (state.succeeded) {
    return (
      <Grid container>
        <Grid size={12} className={styles.centerItem} height={300}>
          <Typography className={styles.aboutUsDescription}>
            Thanks for your submission!
          </Typography>
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid container justifyContent="center">
      <Grid
        size={{ xs: 11, sm: 11, md: 11, lg: 8, xl: 7 }}
        className={styles.contactContainer}
      >
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{
            duration: 1,
            ease: "easeInOut",
            delay: 0.3,
          }}
          viewport={{ once: true }}
        >
          <Grid container rowSpacing={1}>
            <Grid size={12} className={styles.centerItem}>
              <Typography className={styles.contactUsTitle}>
                CONNECT WITH JP CAPITAL
              </Typography>
            </Grid>
            <Grid size={12} className={styles.centerItem}>
              <Typography className={styles.aboutUsDescription}>
                Have questions or need assistance? Fill out the form below, and
                our team will reach out to you.
              </Typography>
            </Grid>
            <Grid
              mt={3}
              size={12}
              className={styles.centerItem}
              sx={{
                "& .MuiOutlinedInput-root": {
                  border: "2px solid #2a75bb",
                  borderRadius: "16px",
                  width: "300px",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "none",
                },
                "& .MuiOutlinedInput-input::placeholder": {
                  fontFamily: "Montserrat-300",
                  fontSize: "13px",
                },
              }}
            >
              <Grid container rowSpacing={2} flexDirection="column">
                <Grid size={12}>
                  <form onSubmit={handleSubmit}>
                    <Grid container rowSpacing={2} flexDirection="column">
                      <Grid>
                        <TextField
                          id="email"
                          name="email"
                          type="email"
                          size="small"
                          placeholder="Email*"
                          required
                          sx={{
                            "& .MuiInputBase-input": {
                              fontFamily: "Inter-400",
                              fontSize: "14px",
                            },
                          }}
                          className={styles.contactInputField}
                        />
                        <ValidationError
                          prefix="Email"
                          field="email"
                          errors={state.errors}
                        />
                      </Grid>

                      <Grid>
                        <TextField
                          id="fullname"
                          name="fullname"
                          type="text"
                          size="small"
                          placeholder="Full name"
                          sx={{
                            "& .MuiInputBase-input": {
                              fontFamily: "Inter-400",
                              fontSize: "14px",
                            },
                          }}
                          className={styles.contactInputField}
                        />
                        <ValidationError
                          prefix="Full name"
                          field="fullname"
                          errors={state.errors}
                        />
                      </Grid>

                      <Grid>
                        <TextField
                          id="phone"
                          name="phone"
                          type="text"
                          size="small"
                          placeholder="Phone number"
                          sx={{
                            "& .MuiInputBase-input": {
                              fontFamily: "Inter-400",
                              fontSize: "14px",
                            },
                          }}
                          className={styles.contactInputField}
                        />
                        <ValidationError
                          prefix="Phone number"
                          field="phone"
                          errors={state.errors}
                        />
                      </Grid>

                      <Grid>
                        <TextField
                          id="company"
                          name="company"
                          type="text"
                          size="small"
                          placeholder="Company name"
                          sx={{
                            "& .MuiInputBase-input": {
                              fontFamily: "Inter-400",
                              fontSize: "14px",
                            },
                          }}
                          className={styles.contactInputField}
                        />
                        <ValidationError
                          prefix="Company name"
                          field="company"
                          errors={state.errors}
                        />
                      </Grid>

                      <Grid className={styles.centerItem}>
                        <Button
                          type="submit"
                          disabled={state.submitting}
                          className={styles.submitFormButton}
                        >
                          Submit form
                        </Button>
                      </Grid>
                    </Grid>
                  </form>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </motion.div>
      </Grid>
    </Grid>
  );
};

export default Contact;
